import MainButton from "../../../components/button/mainButton";
import Icon from "@mdi/react";
import {
  mdiPrinter,
  mdiClipboardMultipleOutline,
  mdiContentPaste,
} from "@mdi/js";
import "../../../assets/styles/admin/booking.scss";
import EmptyModel from "../../../components/modal/emptyModal";
import { useCallback, useEffect, useRef, useState } from "react";
import CheckboxText from "../../../components/textfield/checkbox";
import SelectField from "../../../components/select/selectField";
import { Input } from "../../../components/textfield";
import FullCalendar, { EventInput, formatDate } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Tooltip } from "bootstrap";
import vector from "../../../assets/images/Vector.png";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { PDFExport } from "@progress/kendo-react-pdf";

let tooltip = null;

const DoctorTable = () => {
  let todayStr = new Date().toISOString().replace(/T.*$/, "");
  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState<any>({
    currentEvents: [],
    copied: false,
  });
  const [boolean, setBoolean] = useState<boolean>();
  const [room, setRoom] = useState<string>();
  const [docTors, setDoctors] = useState<string>();
  const [timeStart, setTimeStart] = useState<string>();
  const [timeEnd, setTimeEnd] = useState<string>();
  const [selectInfo, setSelectInfo] = useState<any>([]);
  const [text_tooltip, settext_tooltip] = useState<string>();
  const [cssName, setCssName] = useState<string>("hide");
  const [data, setData] = useState<any>({
    values: [],
  });
  const [event, setEvent] = useState<any>({
    values: [
      {
        title: "Doc Hair : นพ.ประเสริฐ พันธุ์พรหมธาดา 10:00AM- 16:00PM",
        start: "2022-02-05",
        color: "#4D7E7F",
      },
    ],
  });

  const pdfExportComponent: any = useRef(null);

  const handleExportWithComponent = () => {
    pdfExportComponent.current.save();
  };

  function onClose() {
    setIsOpen(false);
  }

  const option = [
    { value: "Room1", name: "Room1" },
    { value: "Room2", name: "Room2" },
    { value: "Room3", name: "Room3" },
  ];

  const doctor = [
    { value: "นายดนุภัทร สมศรี1", name: "นายดนุภัทร สมศรี1" },
    { value: "นายดนุภัทร สมศรี2", name: "นายดนุภัทร สมศรี2" },
    { value: "นายดนุภัทร สมศรี3", name: "นายดนุภัทร สมศรี3" },
  ];

  // const data: EventInput[] = ;

  // useEffect(() => {
  //   getAPIs();
  // }, []);

  const getAPIs = () => {};

  const handleDateSelect = (selectInfo: any) => {
    setSelectInfo(selectInfo);
    setIsOpen(true);
  };

  const handleEventClick = (clickInfo: any) => {
    if (
      window.confirm(
        `Are you sure you want to delete the event '${text_tooltip}'`
      )
    ) {
      clickInfo.event.remove();
    }
  };

  function createEventId() {
    let eventGuid = 0;
    return String(eventGuid++);
  }

  function renderEventContent(eventInfo: any) {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <i>{eventInfo.event.title} </i>
          <img
            src={vector}
            alt=""
            style={{
              alignItems: "center",
              width: "16px",
              height: "16px",
            }}
          />
        </div>
      </>
    );
  }

  const handleEvents = (events: any) => {
    setState({
      currentEvents: events,
    });
  };

  const createData = (selectInfo: any) => {
    let values = data.values;
    let title = `${room} : ${docTors} ${timeStart} - ${timeEnd}`;

    settext_tooltip(title);
    if (title.length >= 20) {
      title = title.substring(0, 20) + "...";
    }
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect();

    // console.log("calendarApi => ", calendarApi);

    values.push({ title: title, start: selectInfo.startStr, color: "#4D7E7F" });
    setData({
      ...data,
      values,
    });

    if (title) {
      calendarApi.addEvent({
        id: createEventId(),
        start: selectInfo.startStr,
        title,
        end: selectInfo.startStr,
        allDay: selectInfo.allDay,
        color: "#4D7E7F",
      });
    }
    setIsOpen(false);
  };

  const handleMouseEnter = (info: any) => {
    if (text_tooltip) {
      tooltip = new Tooltip(info.el, {
        title: text_tooltip,
        html: true,
        placement: "top",
        trigger: "hover",
        container: "body",
      });

      tooltip.show();
    }
  };

  const handleMouseLeave = (info: any) => {
    tooltip = new Tooltip(info.el, {
      html: true,
      placement: "top",
      container: "body",
    });
    if (tooltip) {
      tooltip.dispose();
      tooltip = null;
    }
  };

  const OnCheckToast = () => {
    if (state.copied == true) {
      setCssName("face show");
    }
    setTimeout(() => {
      setCssName("face hide");
    }, 3000);
  };

  const OnChangePaste = () => {
    setEventPaste();
  };

  const setEventPaste = () => {
    // setEvent({ ...event, values: data.values });
    setEvent({
      ...event,
      values: [
        {
          title: "Room3 : นายดนุภัทร สมศรี2 16:49 - 20:49",
          start: "2022-03-17",
          color: "#4D7E7F",
        },
        {
          title: "Room2 : นายดนุภัทร สมศรี2 16:00 - 20:30",
          start: "2022-03-18",
          color: "#4D7E7F",
        },
        {
          title: "Room1 : นายดนุภัทร สมศรี2 18:50 - 20:00",
          start: "2022-03-25",
          color: "#4D7E7F",
        },
      ],
    });
    console.log(event);
  };

  return (
    <div style={{ padding: "0px 40px" }}>
      <div className="create-page" style={{ padding: "0px 10px" }}>
        <EmptyModel show={isOpen} onClose={onClose} width="60%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>เพิ่มข้อมูล</h4>
            <div className="row">
              <div style={{ color: "#5baea9", fontSize: "14px" }}>สำหรับ</div>
              <CheckboxText
                className="col-2"
                id="1"
                title="วันนี้"
                onChange={(e) => {
                  setBoolean(e.target.checked);
                }}
              />
              <CheckboxText
                className="col-2"
                id="1"
                title="สัปดาห์นี้"
                onChange={(e) => {
                  setBoolean(e.target.checked);
                }}
              />
              <CheckboxText
                className="col-2"
                id="1"
                title="เดือนนี้"
                onChange={(e) => {
                  setBoolean(e.target.checked);
                }}
              />
              <SelectField
                title="ห้อง"
                className="col-4"
                option={option}
                value={room}
                onChange={(e) => {
                  setRoom(e.target.value);
                }}
              />
            </div>
            <div className="row">
              <SelectField
                title="แพทย์"
                className="col-4"
                option={doctor}
                value={docTors}
                onChange={(e) => {
                  setDoctors(e.target.value);
                }}
              />
              <Input
                className="col-3"
                title="เวลา"
                type="time"
                value={timeStart}
                onChange={(e) => {
                  setTimeStart(e.target.value);
                }}
              />
              <span
                style={{
                  fontSize: "14px",
                  color: "#5BAEA9",
                  width: "16px",
                  paddingTop: "2%",
                }}
              >
                ถึง
              </span>
              &nbsp;
              <Input
                className="col-3"
                title="เวลา"
                type="time"
                value={timeEnd}
                onChange={(e) => {
                  setTimeEnd(e.target.value);
                }}
              />
            </div>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
              <MainButton
                className="mg-10"
                title="บันทึกข้อมูล"
                onClick={() => {
                  createData(selectInfo);
                }}
              />
            </div>
          </div>
        </EmptyModel>
        <div className="row">
          <div className="slect-booking">
            <div className="booking-datePicker">
              {/* <DatePicker size={`middle`} bordered={false} /> */}
            </div>
            <div className="booking-btnPrint">
              <div
                className="position-fixed bottom-0 end-0 p-3"
                style={{ zIndex: 11 }}
              >
                <div
                  id="liveToast"
                  className={`toast ${cssName}`}
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div className="toast-body">Success !!!</div>
                </div>
              </div>
              <CopyToClipboard
                text={JSON.stringify(data)}
                onCopy={() => {
                  setState({ copied: true });
                }}
              >
                <MainButton
                  title=""
                  width="50px"
                  className="mg-10"
                  background="#FFF"
                  color="#000000"
                  border="1px solid #263544"
                  onClick={OnCheckToast}
                  display="block"
                >
                  <Icon
                    path={mdiClipboardMultipleOutline}
                    size="20"
                    color="#000000"
                  />
                </MainButton>
              </CopyToClipboard>
              <MainButton
                title=""
                width="50px"
                className="mg-10"
                background="#FFF"
                color="#000000"
                border="1px solid #263544"
                onClick={OnChangePaste}
                display="block"
              >
                <Icon path={mdiContentPaste} size="20" color="#000000" />
              </MainButton>
              <MainButton
                title="Print"
                width="90px"
                className="mg-10"
                onClick={handleExportWithComponent}
              >
                <Icon path={mdiPrinter} size="20" color="#FFFFFF" />
              </MainButton>
            </div>
          </div>
        </div>
        <div id="example">
          <PDFExport ref={pdfExportComponent}>
            <div
              style={{ padding: "20px 10px", backgroundColor: "#FFFFFF" }}
              id="divToPrint"
            >
              {/* <FullCalendar
                initialView="dayGridMonth"
                plugins={[dayGridPlugin, interactionPlugin]}
                headerToolbar={{
                  right: "today prev,next",
                  left: "title",
                }}
                editable={true}
                selectable={true}
                selectMirror={true}
                dayMaxEvents={true}
                select={handleDateSelect}
                // eventClick={handleEventClick}
                eventContent={renderEventContent}
                // eventsSet={handleEvents}
                eventMouseEnter={handleMouseEnter}
                eventMouseLeave={handleMouseLeave}
                events={event.values}
              /> */}
            </div>
          </PDFExport>
        </div>
      </div>
    </div>
  );
};
export default DoctorTable;
